import React, { useMemo } from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import lang from '@/lang'
import ThemeInterface from '@/theme-interface'
import { MultiSelectItemObj } from '@/components/multi-select/types'
import { getMultiSelectItemInfoLabel } from '@/components/multi-select/helpers/getItemLabel'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  item: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0px 17px',
    padding: '17px 0px',
    borderBottom: `1px solid ${theme.borderColors.default}`,
    cursor: 'pointer',
    '&:hover': {
      color: theme.borderColors.outline,
    },
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  active: {
    color: theme.primary,
  },
  label: {
    fontSize: theme.fontSizes.small,
  },
  details: {
    fontSize: theme.fontSizes.extrasmall,
    color: theme.labelLight,
    marginTop: 5,
  },
  info: {
    borderRight: `1px solid ${theme.labelLight}`,
    paddingRight: 10,
    marginRight: 10,
  },
}))

type MultiSelectItemProps = {
  label: string,
  item: MultiSelectItemObj,
  active: boolean,
  onClick?: (item) => void
}

const MultiSelectItem = (props: MultiSelectItemProps) => {
  const classes = useStyles()
  const {
    label = '',
    item = null,
    active = false,
    onClick,
  } = props

  const details = useMemo(() => {
    if (!item) { return '' }
    const info = getMultiSelectItemInfoLabel(item)
    return (
      <>
        {info && <span className={classes.info}>{info}</span>}
        <span>{lang.emailLabel}: {item.email || lang.generics.emptyProp}</span>
      </>
    )
  }, [])

  const className = clsx(classes.item, active && classes.active)
  return (
    <div
      className={className}
      onClick={() => {
        onClick?.(item)
      }}
    >
      <span className={classes.label}>{label}</span>
      <span className={classes.details}>{details}</span>
    </div>
  )
}

export default MultiSelectItem
